import PublicArticleFolderDetailsContent from './publicArticleFolderDetailsContent';
import PublicArticleFolderPageHeader from './publicArticleFolderPageHeader';
import '../../../css/articleFolder/publicArticleFolder.css';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useCallback, useEffect, useState } from 'react';
import PublicArticleItems from './publicArticleItems';
import { Box, CircularProgress } from '@mui/material';
import { useParams } from 'react-router-dom';
import NoRecord from '../../NoRecord';
import axios from 'axios';

const PublicArticleFolderDetails = () => {

    const { token } = useParams();

    const [errMsg, setErrMsg] = useState(null);
    const [loading, setLoading] = useState(true);
    const [articleFolder, setArticleFolder] = useState({});

    const fetchArticleFolderDetails = useCallback(async ({ silent = false } = {}) => {
        try {
            if (!silent) {
                setLoading(true);
            }
            const { data, status } = await axios.get(`article-folder/findOneForQrCodeReview/${token}`, {
                skipSessionTrace: true,
            });
            if (status === 200 || status === 201) {
                setArticleFolder(data);
            }
        } catch (error) {
            if (!silent) {
                setErrMsg(error.message);
            }
            console.error('Erreur lors de la récupération des informations du dossiser :', error);
            CustomErrorLogger(error, 'Erreur dans fetchArticleFolderDetails');
        }
        finally {
            if (!silent) {
                setLoading(false);
            }
        }
    }, [token]);

    useEffect(() => {
        fetchArticleFolderDetails();
        const renewId = setInterval(() => fetchArticleFolderDetails({ silent: true }), 3 * 60 * 60 * 1000);
        return () => clearInterval(renewId);
    }, [fetchArticleFolderDetails]);

    return (
        <Box>
            {loading ?
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh', }}>
                    <CircularProgress
                        sx={{
                            '& .MuiCircularProgress-circle': { stroke: '#EA5E00' },
                        }}
                    />
                </Box>
                :
                errMsg ?
                    <NoRecord description="Dossier non trouvée" />
                    :
                    <Box className="publicArticleFolder_page">
                        <PublicArticleFolderPageHeader
                            articleFolderTitle={articleFolder?.title || ''}
                        />
                        <PublicArticleFolderDetailsContent
                            articleFolderDescription={articleFolder?.description || ''}
                            articleFolder={articleFolder}
                        />
                        <PublicArticleItems
                            articleFolderItem={articleFolder?.article || []}
                        />
                    </Box>
            }
        </Box>
    );
}

export default PublicArticleFolderDetails;